import { CheckCircle2 } from "lucide-react";

export default function Eligibility({ eligibilities }: any) {
  if (!eligibilities) return null;

  return (
    <div className="flex flex-col gap-2 py-4 w-full">
      <p className="font-medium text-[#171717] text-[16px] tracking-[-0.32px] leading-normal">
        Eligibility
      </p>
      <div className="flex flex-col gap-3 pl-2">
        {eligibilities?.map((requirement: any, index: number) => (
          <div key={index} className="flex gap-1.5 items-center">
            <CheckCircle2 size={18} className="text-[var(--color-green-9)]" />
            <p className="font-normal text-[var(--color-black-7)] text-[14px] tracking-[-0.56px] leading-[1.35]">
              {requirement.value}% {requirement.qualificationName}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
